// TG GRACIAS A MI SEÑOR DIOS TG TG TG
// AboutMe.js
import React, { useEffect, useContext } from "react";
import { motion } from "framer-motion";
import "./App.css";
import WhoAmIBg from "./images/who-am-i-eleven-fit-image-3-TG.png";
import { AppContext } from "./ContextVars";
import translations from './translations';

const AboutMe = () => {

  const { language } = useContext(AppContext);
  const t = (key) => translations.AboutMe[key]?.[language] || key;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <main>
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4 }}
        >
        {/* Hero Section — same image as the Who Am I section */}
        <section
          id="about"
          className="section overlay tint-black-40"
          style={{
            height: "auto",
            padding: 0,
            flexDirection: "column",
            justifyContent: "flex-start",
            backgroundImage: "none",
          }}
        >
          <img
            src={WhoAmIBg}
            alt="Oscar - Eleven.fit"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
          />
          <div
            className="section__content"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h2 className="general-title">{t('title')}</h2>
            <h2 className="font-size-20 color-gray-3">
              {t('subtitle')}
            </h2>
          </div>
        </section>

        {/* Bio Section */}
        <section className="section-2 bg-image-floor overlay tint-black-50">
          <div className="section__content">
            <div className="gdiv width-80 gap-20px">
              <h2 className="general-title text-align-left move-left text-shadow">
                {t('name')}
              </h2>

              <div className="general-description text-align-left move-left text-shadow margin-top-20">
                <p className="margin-bottom-20" dangerouslySetInnerHTML={{ __html: t('bio1') }} />
                <p className="margin-bottom-20" dangerouslySetInnerHTML={{ __html: t('bio2') }} />
                <p className="margin-bottom-20" dangerouslySetInnerHTML={{ __html: t('bio3') }} />
                <p className="margin-bottom-20" dangerouslySetInnerHTML={{ __html: t('bio4') }} />
              </div>
            </div>

            {/* What I Offer */}
            <div className="gdiv width-80 gap-20px margin-top-100">
              <h2 className="general-title text-align-left move-left text-shadow">
                {t('whatIBring')}
              </h2>

              <div className="general-description text-align-left move-left text-shadow margin-top-20">
                <ul>
                  <li className="margin-bottom-20">
                    <strong className="color-1">{t('item1Title')}</strong>{" "}
                    {t('item1Desc')}
                  </li>
                  <li className="margin-bottom-20">
                    <strong className="color-1">{t('item2Title')}</strong>{" "}
                    {t('item2Desc')}
                  </li>
                  <li className="margin-bottom-20">
                    <strong className="color-1">{t('item3Title')}</strong>{" "}
                    {t('item3Desc')}
                  </li>
                  <li className="margin-bottom-20">
                    <strong className="color-1">{t('item4Title')}</strong>{" "}
                    {t('item4Desc')}
                  </li>
                </ul>
              </div>
            </div>

            {/* Fun Facts */}
            <div className="gdiv width-80 gap-20px margin-top-100 margin-bottom-100">
              <h2 className="general-title text-align-left move-left text-shadow">
                {t('funFacts')}
              </h2>

              <div className="general-description text-align-left move-left text-shadow margin-top-20">
                <ul>
                  <li className="margin-bottom-20" dangerouslySetInnerHTML={{ __html: t('fact1') }} />
                  <li className="margin-bottom-20" dangerouslySetInnerHTML={{ __html: t('fact2') }} />
                  <li className="margin-bottom-20" dangerouslySetInnerHTML={{ __html: t('fact3') }} />
                  <li className="margin-bottom-20" dangerouslySetInnerHTML={{ __html: t('fact4') }} />
                </ul>
              </div>
            </div>
          </div>
        </section>
        </motion.div>
      </main>
    </div>
  );
};

export default AboutMe;
